import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowForwardRounded, ArrowBackRounded, BusinessOutlined } from "@mui/icons-material";
import "./companyInformationPage.css";

const information = {
  affiliates: ["Affiliates", "Information about affiliate opportunities is being prepared."],
  partners: ["Partners", "Our partnership information is being prepared."],
  security: ["Security", "A detailed overview of our security practices is being prepared."],
  developers: ["API & Developers", "Our API and developer information is being prepared."],
  support: ["Contact Support", "Need assistance? Our contact page is available now."],
  blog: ["Blog & Updates", "Product news and learning resources will appear here."],
};

export default function CompanyInformationPage() {
  const { section } = useParams();
  const [title, description] = information[section] || ["Company", "This information is not yet available."];
  return (
    <main className="company-info-page">
      <Link className="company-info-home" to="/"><ArrowBackRounded /> Universe Inventory</Link>
      <section className="company-info-card">
        <span className="company-info-icon"><BusinessOutlined /></span>
        <span className="company-info-label">UNIVERSE TECHNOLOGY INDUSTRY</span>
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="company-info-actions">
          <Link to="/contact-us" className="company-info-contact">Contact us <ArrowForwardRounded /></Link>
          <Link to="/about-us" className="company-info-about">About Universe Inventory</Link>
        </div>
      </section>
    </main>
  );
}
